import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

import {
  guestInfoFormDefaultValues,
  guestVerificationFormDefaultValues,
  termsFormDefaultValues,
  TGuestInfoForm,
  TTermsForm,
  TVerificationData,
} from './sign-up-form'

type SignUpGuestStore = {
  terms: TTermsForm
  info: TGuestInfoForm
  verification: TVerificationData
  actions: {
    updateTerms: (data: TTermsForm) => void
    updateInfo: (data: TGuestInfoForm) => void
    updateVerification: (data: TVerificationData) => void
    reset: () => void
  }
}
const initialState = {
  terms: termsFormDefaultValues,
  info: guestInfoFormDefaultValues,
  verification: guestVerificationFormDefaultValues,
}

export const useSignUpGuestStore = create<SignUpGuestStore>()(
  subscribeWithSelector(set => ({
    ...initialState,
    actions: {
      updateTerms: data => {
        set(state => ({
          terms: { ...state.terms, ...data },
        }))
      },
      updateInfo: data => {
        set(state => ({
          info: { ...state.info, ...data },
        }))
      },
      updateVerification: data => {
        set(state => ({
          verification: { ...state.verification, ...data },
        }))
      },
      reset: () => {
        set(initialState)
      },
    },
  })),
)
